import * as s from "react";
import * as S from "react-dom";
import { p as l } from "./index-efd35e77.js";
import { B as j } from "./Button-4c83e316.js";
import { x as K } from "./index.es-6889c727.js";
import { l as Z, v as B } from "./index-64063129.js";
var L = function(o) {
  var e = o.children, n = o.onCloseButtonClick, t = o.id, r = o.closeIcon;
  return s.createElement(
    "div",
    { className: "k-window-titlebar k-dialog-titlebar", id: t },
    s.createElement("div", { className: "k-window-title k-dialog-title" }, e),
    s.createElement("div", { className: "k-window-titlebar-actions k-dialog-titlebar-actions" }, r && s.createElement(j, { role: "button", "aria-label": "Close", onClick: n, icon: "x", svgIcon: K, fillMode: "flat", className: "k-window-titlebar-action k-dialog-titlebar-action" }))
  );
}, h = s.createContext(0);
h.displayName = "KendoReactZIndexContext";
var R = !!// from fbjs
(typeof window < "u" && window.document && window.document.createElement), k = function() {
  for (var o = [], e = 0; e < arguments.length; e++)
    o[e] = arguments[e];
  var n = {}, t = function(a) {
    return typeof a == "object" ? Object.keys(a).forEach(function(i) {
      n[i] = a[i];
    }) : n[a] = !0;
  }, r = function(a) {
    return a.filter(function(i) {
      return i !== !0 && !!i;
    }).map(function(i) {
      return Array.isArray(i) ? r(i) : t(i);
    });
  };
  return r(o), Object.keys(n).map(function(a) {
    return n[a] && a || null;
  }).filter(function(a) {
    return a !== null;
  }).join(" ");
}, U = function() {
  var o = "", e, n;
  for (e = 0; e < 32; e++)
    n = Math.random() * 16 | 0, (e === 8 || e === 12 || e === 16 || e === 20) && (o += "-"), o += (e === 12 ? 4 : e === 16 ? n & 3 | 8 : n).toString(16);
  return o;
}, I = {
  backspace: 8,
  tab: 9,
  enter: 13,
  shift: 16,
  esc: 27,
  space: 32,
  pageUp: 33,
  pageDown: 34,
  end: 35,
  home: 36,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  delete: 46
};
function M(o) {
  if (typeof Z < "u")
    B(o);
  else {
    var e = "License activation failed for ".concat(o.name, `
`);
    e += `The @progress/kendo-licensing script is not loaded.
`, e += "See ".concat(o.licensingDocsUrl, ` for more information.
`), console.warn(e);
  }
}
function W(o, e, n, t) {
  if (o) {
    var r = {
      syntheticEvent: e,
      nativeEvent: e.nativeEvent,
      target: n
    };
    o.call(void 0, Object.assign(r, t));
  }
}
var z = function(o, e) {
  var n = s.useContext(o), t = n(e);
  return t;
}, g = globalThis && globalThis.__assign || function() {
  return g = Object.assign || function(o) {
    for (var e, n = 1, t = arguments.length; n < t; n++) {
      e = arguments[n];
      for (var r in e)
        Object.prototype.hasOwnProperty.call(e, r) && (o[r] = e[r]);
    }
    return o;
  }, g.apply(this, arguments);
}, G = function() {
  return s.createContext(function(o) {
    return o;
  });
}, $ = function(o, e) {
  return s.forwardRef(function(n, t) {
    var r = z(o, n);
    return s.createElement(e, g({}, r, { ref: t }));
  });
}, q = function(o) {
  if (o) {
    var e = o.activeElement, n = e == null ? void 0 : e.shadowRoot;
    return n ? n.activeElement : e;
  }
}, m = function(o) {
  var e, n = o.layout, t = n === void 0 ? F.layout : n, r = o.children, a = k("k-actions", "k-actions-horizontal", "k-window-actions k-dialog-actions", (e = {}, e["k-actions-".concat(t)] = t, e));
  return s.createElement("div", { className: a }, r);
};
m.propTypes = {
  children: l.any,
  layout: l.oneOf(["start", "center", "end", "stretched"])
};
var F = {
  layout: "stretched"
}, X = {
  name: "@progress/kendo-react-dialogs",
  productName: "KendoReact",
  productCodes: ["KENDOUIREACT", "KENDOUICOMPLETE"],
  publishDate: 1686225582,
  version: "",
  licensingDocsUrl: "https://www.telerik.com/kendo-react-ui/my-license/?utm_medium=product&utm_source=kendoreact&utm_campaign=kendo-ui-react-purchase-license-keys-warning"
}, b = "data-windowid", V = 10002, y = 2, J = ".k-window:not(.k-dialog), .k-dialog-wrapper", Q = function(o, e, n) {
  var t = o;
  if (e && e.defaultView) {
    var r = e.querySelectorAll(J), a = !1;
    return r.forEach(function(i) {
      var c = e.defaultView.getComputedStyle(i, null), u = i.getAttribute(b);
      if (u !== n && c.zIndex !== null) {
        var d = parseInt(c.zIndex, 10);
        d >= t && (t = d, a = !0);
      }
    }), a ? t + y : t;
  }
  return t;
}, Y = globalThis && globalThis.__extends || function() {
  var o = function(e, n) {
    return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, r) {
      t.__proto__ = r;
    } || function(t, r) {
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (t[a] = r[a]);
    }, o(e, n);
  };
  return function(e, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    o(e, n);
    function t() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (t.prototype = n.prototype, new t());
  };
}(), v = globalThis && globalThis.__assign || function() {
  return v = Object.assign || function(o) {
    for (var e, n = 1, t = arguments.length; n < t; n++) {
      e = arguments[n];
      for (var r in e)
        Object.prototype.hasOwnProperty.call(e, r) && (o[r] = e[r]);
    }
    return o;
  }, v.apply(this, arguments);
}, H = (
  /** @class */
  function(o) {
    Y(e, o);
    function e(n) {
      var t = o.call(this, n) || this;
      return t.context = 0, t._id = U(), t.titleId = t.generateTitleId(), t.contentId = t.generateContentId(), t.onCloseDialog = function(r) {
        r.preventDefault(), W(t.props.onClose, r, t, void 0);
      }, t.onKeyDown = function(r) {
        r.keyCode === I.esc && t.props.onClose && (r.preventDefault(), t.onCloseDialog(r));
        var a = t.element;
        if (a && r.keyCode === I.tab) {
          var i = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])', c = a.querySelectorAll(i), u = c[0], d = c[c.length - 1], p = t.getDocument(), f = q(p);
          r.shiftKey ? (p && f === u || p && f === t.element) && (d.focus(), r.preventDefault()) : p && f === d && (u.focus(), r.preventDefault());
        }
      }, t.getCurrentZIndex = function() {
        return !t.state || t.context === void 0 ? t.context ? t.context : V : t.state.zIndex > (t.context ? t.context + y : 0) ? t.state.zIndex : t.context + y;
      }, t.getDocument = function() {
        return t.props.appendTo ? t.props.appendTo.ownerDocument : document;
      }, M(X), t.state = {
        zIndex: Q(t.getCurrentZIndex(), t.getDocument(), t._id)
      }, t;
    }
    return e.prototype.componentDidMount = function() {
      this.element && this.props.autoFocus && this.element.focus();
    }, e.prototype.render = function() {
      var n, t, r = this, a = this.props.id !== void 0 ? this.props.id : this.titleId, i = this.props, c = i.title, u = i.width, d = i.height, p = i.children, f = i.minWidth, D = i.dir, _ = i.style, E = i.contentStyle, w = s.Children.toArray(p), O = this.getContent(w), T = this.getActionBar(w), A = c ? {
        "aria-labelledby": a
      } : null, N = this.props.closeIcon !== void 0 ? this.props.closeIcon : !0, x = this.getCurrentZIndex(), C = s.createElement(
        h.Provider,
        { value: x },
        s.createElement(
          "div",
          v({}, (n = {}, n[b] = this._id, n), { className: "k-dialog-wrapper" + (this.props.className ? " " + this.props.className : ""), onKeyDown: this.onKeyDown, tabIndex: 0, dir: D, style: v({ zIndex: x }, _), ref: function(P) {
            return r.element = P;
          } }),
          s.createElement("div", { className: "k-overlay" }),
          s.createElement(
            "div",
            v({}, A, { className: k("k-window k-dialog", (t = {}, t["k-window-".concat(this.props.themeColor)] = this.props.themeColor, t)), role: "dialog", "aria-labelledby": a, "aria-modal": !0, "aria-describedby": this.contentId, style: { width: u, height: d, minWidth: f } }),
            this.props.title && s.createElement(L, { closeIcon: N, onCloseButtonClick: this.onCloseDialog, id: a }, c),
            s.createElement("div", { className: "k-window-content k-dialog-content", style: E, id: this.contentId }, O),
            T
          )
        )
      );
      return R ? this.props.appendTo !== null ? S.createPortal(C, this.props.appendTo || document.body) : C : null;
    }, e.prototype.getActionBar = function(n) {
      return n.filter(function(t) {
        return t && t.type === m;
      });
    }, e.prototype.getContent = function(n) {
      return n.filter(function(t) {
        return t && t.type !== m;
      });
    }, e.prototype.generateTitleId = function() {
      return "dialog-title" + this._id;
    }, e.prototype.generateContentId = function() {
      return "dialog-content" + this._id;
    }, e.displayName = "Dialog", e.propTypes = {
      title: l.any,
      id: l.string,
      dir: l.string,
      style: l.object,
      closeIcon: l.bool,
      width: l.oneOfType([l.number, l.string]),
      height: l.oneOfType([l.number, l.string]),
      minWidth: l.oneOfType([l.number, l.string]),
      autoFocus: l.bool
    }, e.defaultProps = {
      autoFocus: !1
    }, e.contextType = h, e;
  }(s.Component)
), tt = G(), et = $(tt, H);
et.displayName = "KendoReactDialog";
export {
  et as D,
  I as K,
  y as Z,
  m as a,
  Q as b,
  k as c,
  W as d,
  V as e,
  h as f,
  U as g,
  b as h,
  R as i,
  G as j,
  X as p,
  M as v,
  $ as w
};
